import { FTU_WIZARD_STEPS, FTU_WIZARD_STEP_DISPLAY_ORDER, FTU_WIZARD_STEP_TO_STEPPER_MAPPING } from '../constants';

export const FTU_WIZARD_STEP_INDICES = {
  [FTU_WIZARD_STEPS.ORDERS]: 1,
  [FTU_WIZARD_STEPS.SHIP_FROM]: 2,
  [FTU_WIZARD_STEPS.CARRIER]: 3,
  [FTU_WIZARD_STEPS.DISCOUNTED_RATES]: 4,
  [FTU_WIZARD_STEPS.ADVANCED_OPTIONS]: 5,
  [FTU_WIZARD_STEPS.INVENTORY_SETUP]: 6,
  [FTU_WIZARD_STEPS.PHONE_NUMBER]: 7,
};

export const getStepIndex = (stepKey) => {
  return FTU_WIZARD_STEP_INDICES[stepKey] || 1;
};

export const getStepKeyFromIndex = (index) => {
  return Object.keys(FTU_WIZARD_STEP_INDICES).find((key) => FTU_WIZARD_STEP_INDICES[key] === index) || FTU_WIZARD_STEPS.ORDERS;
};

export const isStepCompleted = (stepKey, currentStepKey) => {
  const stepIndex = getStepIndex(stepKey);
  const currentStepIndex = getStepIndex(currentStepKey);
  return stepIndex < currentStepIndex;
};

// New utility for stepper mapping
export const getStepperStepForWizardStep = (stepKey) => {
  return FTU_WIZARD_STEP_TO_STEPPER_MAPPING[stepKey] || 1;
};

// Utility to get step index from display order
export const getStepIndexFromDisplayOrder = (stepKey) => {
  return FTU_WIZARD_STEP_DISPLAY_ORDER.indexOf(stepKey);
};
